import React from 'react'
import { Background, ModalBody, ModalContent, ModalHeader, ModalCancelBtn } from './modal.style'
import { AnimatePresence } from 'framer-motion'
import ReactDOM from "react-dom";
import { MdClose } from 'react-icons/md'

const backdrop = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
}

const modal = {
    hidden: { y: "-100vh", opacity: 0 },
    visible: { y: "0px", opacity: 1, transition: { delay: 0.3 } },
}

const CustomModal = ({ children, showModal, title, onClose }) => {
    // if (!showModal) {
    //     return null
    // }
    return (
        ReactDOM.createPortal(
            <AnimatePresence exitBeforeEnter>
                {showModal ? (
                    <Background onClick={onClose} variants={backdrop} initial="hidden" animate="visible" exit="hidden" >
                        <ModalContent variants={modal}
                            onClick={e => e.stopPropagation()} >
                            <ModalCancelBtn onClick={onClose}>
                                <MdClose />
                            </ModalCancelBtn>
                            <ModalHeader>
                                {title}
                            </ModalHeader>
                            <ModalBody>
                                {children}
                            </ModalBody>
                            {/* <ModalFooter>
                                <Button variant="secondary" onClick={onClose}>
                                    cancel
                                </Button>
                            </ModalFooter> */}
                        </ModalContent>
                    </Background >
                ) : null}
            </AnimatePresence>, document.getElementById("root")
        )
    )
}

export { CustomModal }
